document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.gido-catering-form__form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    var errors = [];

    var name = form.querySelector('#catering-name');
    if (!name.value.trim()) errors.push('Please enter your name.');

    var email = form.querySelector('#catering-email');
    if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()))
      errors.push('Please enter a valid email address.');

    var message = form.querySelector('#catering-message');
    if (!message.value.trim()) errors.push('Please tell us about your event.');

    var box = document.getElementById('catering-errors');
    if (errors.length) {
      e.preventDefault();
      box.innerHTML = errors.map(function (m) { return '<p>' + m + '</p>'; }).join('');
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      box.hidden = true;
    }
  });
});
